// keys used to access all storage items - cookies, session, local
export const Cookie = {
	SAPI_COMPANY_ACCOUNT: 'sapi_company_account',
	SAPI_LANGUAGE: 'sapi_language',
	SAPI_CUSTOM_TRANSLATIONS: 'sapi_custom_translations',
};

export const LocalStorageKeys = {
	ProjectTaskListDoneFilter: 'project-task-list-done-filter',
	ProjectTaskListSortState: 'project-task-list-sort-state',
	SubtaskListDoneFilter: 'subtask-list-done-filter',
	SubtaskListSortState: 'subtask-list-sort-state',
	SubtaskListOpenTasks: 'subtask-list-open-tasks',
	TaskDataShowTotals: 'task-data-show-totals',
};
